// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/descriptions/style/index.less
// module id = 1190
// module chunks = 0